/**
 * useGraphiteTheme
 *
 * Single source of truth for "is the Graphite theme active right now?".
 * Mirrors useTerminalTheme — reads the active theme from ThemeCustomizerContext
 * and compares slug. Keep the slug check here, not scattered across surfaces.
 */

import { useThemeCustomizer } from '../contexts/ThemeCustomizerContext';

export function useGraphiteTheme(): boolean {
  const { activeTheme } = useThemeCustomizer();
  // True for the graphite FAMILY — graphite itself OR a variant (e.g. Blossom)
  // that reuses graphite's chrome + scoped SCSS via appThemeAttr.
  return activeTheme?.slug === 'graphite' || (activeTheme as any)?.appThemeAttr === 'graphite';
}
